module.exports = "<button class='btn btn-primary-outline' (click)=\"goToShipmentView(rowData)\">TRACCIA</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shipment-in-progress/button-shipment-view/button-shipment-view.component.html
// module id = ./src/app/shipment-in-progress/button-shipment-view/button-shipment-view.component.html
// module chunks = main